import {
  Component,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { PasswordRequirements } from '@digital-platform/users/domain';
import { PASSWORD_REQUIREMENTS } from '../users-ui.module';

interface CharacterType {
  type: string;
  description: string;
  met: boolean;
}

@Component({
  selector: 'digital-platform-password-feedback',
  templateUrl: './password-feedback.component.html',
  styleUrls: ['./password-feedback.component.scss'],
})
export class PasswordFeedbackComponent implements OnInit, OnChanges {
  @HostBinding() class = 'digital-platform-password-feedback';

  @Input() public password = '';

  public minLength = 0;
  public minLengthMet = false;
  public minCharacterTypes = 0;
  public minCharacterTypesMet = false;
  public totalCharacterTypes = 0;
  public characterTypes: CharacterType[] = [];

  constructor(
    @Inject(PASSWORD_REQUIREMENTS) private requirements: PasswordRequirements
  ) {}

  ngOnInit(): void {
    this.minLength = this.requirements.minLength;
    this.minCharacterTypes = this.requirements.minCharacterTypes;
    this.totalCharacterTypes = this.requirements.characterTypes.length;
    this.characterTypes = this.requirements.characterTypes.map((t) => ({
      type: t.type,
      description: t.description,
      met: false,
    }));

    this.checkPassword();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.password) {
      this.password = this.password || '';
      this.checkPassword();
    }
  }

  private checkPassword() {
    this.minLengthMet = this.password.length >= this.minLength;

    this.characterTypes = this.requirements.characterTypes.map((t) => ({
      type: t.type,
      description: t.description,
      met: t.pattern.test(this.password),
    }));

    const metCharacterTypes = this.characterTypes
      .map((t) => t.met)
      .filter((met) => met).length;

    this.minCharacterTypesMet = metCharacterTypes >= this.minCharacterTypes;
  }
}
